import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FeatureFlagService } from '../service/feature-flag/feature-flag.service';
import { FeatureFlag } from '../model/feature-flag.model';
import { ROUTE_NOT_FOUND } from '../app.constants';

/**
 * Configurable guard to check if a feature flag is enabled.
 * Uses the app-specific feature-flag service and redirects to not-found if disabled.
 * Usage:
 * ```typescript
 * export const appRoutes: Route[] = [
 *   {
 *     path: '',
 *     component: FrontpageComponent,
 *     canActivate: [featureFlagGuard(FeatureFlags.SPOTTARIF)],
 *     children: [],
 *   },
 * ```
 */
export function featureFlagGuard(flag: FeatureFlag): CanActivateFn {
  return async () => {
    const router = inject(Router);
    const featureFlagService = inject(FeatureFlagService);
    const enabled = await firstValueFrom(featureFlagService.getFeatureFlagStatus(flag));
    return enabled ? true : router.parseUrl(`/${ROUTE_NOT_FOUND}`);
  };
}
